import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import customFetch from '@utils/customFetch';
import { Header } from '../components';

const AcceptInvitation = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  const token = searchParams.get('token');
  const companyId = searchParams.get('company');

  useEffect(() => {
    const acceptInvitation = async () => {
      if (!token || !companyId) {
        setStatus('error');
        setMessage('Ungültiger Einladungslink.');
        return;
      }

      try {
        const { data } = await customFetch.post('/auth/accept-invitation', {
          token,
          companyId,
        });
        setStatus('success');
        setMessage(data.msg);
      } catch (error) {
        const errMsg =
          error?.response?.data?.msg || 'Fehler beim Annehmen der Einladung.';

        // Falls nicht eingeloggt → zum Login weiterleiten
        if (error?.response?.status === 401) {
          setStatus('auth_required');
          setMessage('Bitte melde dich zuerst an, um die Einladung anzunehmen.');
          return;
        }

        setStatus('error');
        setMessage(errMsg);
      }
    };

    acceptInvitation();
  }, [token, companyId]);

  return (
    <>
      <Header />
      <div className="h-full bg-gray-50" style={{ height: '100vh' }}>
        <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            {status === 'loading' && (
              <h2 className="text-center text-2xl font-bold text-gray-900">
                Einladung wird verarbeitet...
              </h2>
            )}

            {status === 'success' && (
              <div className="text-center">
                <h2 className="text-2xl font-bold text-gray-900">{message}</h2>
                <p className="mt-4 text-gray-600">
                  Du kannst jetzt auf das Firmen-Dashboard zugreifen.
                </p>
                <Link
                  to="/dashboard"
                  className="mt-6 inline-block rounded-md bg-svisit-primary-600 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-svisit-primary-500"
                >
                  Zum Dashboard
                </Link>
              </div>
            )}

            {status === 'auth_required' && (
              <div className="text-center">
                <h2 className="text-2xl font-bold text-gray-900">{message}</h2>
                <Link
                  to={`/login?redirectURL=${encodeURIComponent(`/invitation/accept?token=${token}&company=${companyId}`)}`}
                  className="mt-6 inline-block rounded-md bg-svisit-primary-600 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-svisit-primary-500"
                >
                  Zum Login
                </Link>
              </div>
            )}

            {status === 'error' && (
              <div className="text-center">
                <h2 className="text-2xl font-bold text-red-600">{message}</h2>
                <Link
                  to="/dashboard"
                  className="mt-6 inline-block text-sm text-svisit-primary-600 hover:underline"
                >
                  Zum Dashboard
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AcceptInvitation;
